export default {
  props: {
    field: {
      type: Object,
      default: () => ({})
    },
    text: {
      type: String,
      default: 'Поле'
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    isValid: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onChange: function (val) {
      this.$emit('change', {
        code: this.field.code,
        value: val
      })
    },
    onValidate: function (val) {
      this.$emit('validate', {
        code: this.field.code,
        value: val
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth/mixins/input.js